import React from "react"

import StoryContestWork from "../atoms/content/StoryContestWork"
import {
  shortShortWorks2021,
  shortWorks2021,
} from "../../storyContest/2021/storyContestWorks"
import {
  shortShortWorks2022,
  shortWorks2022,
} from "../../storyContest/2022/storyContestWorks"
import classes from "./StoryContestWorks.module.scss"

type Props = {
  kind: "shortShort" | "short"
  archive?: boolean
}

const StoryContestWorks: React.FC<Props> = ({ kind, archive }) => {
  const shortShortWorks = archive ? shortShortWorks2021 : shortShortWorks2022
  const shortWorks = archive ? shortWorks2021 : shortWorks2022
  return (
    <>
      <div className={classes.StoryContestWorks}>
        <p>
          <em>
            ※作品は、作者の同意の上、応募された状態のままで掲載しております。
          </em>
        </p>
        {kind === "shortShort"
          ? shortShortWorks.map(el => (
              <StoryContestWork data={el} key={el.title} />
            ))
          : shortWorks.map(el => <StoryContestWork data={el} key={el.title} />)}
      </div>
    </>
  )
}

export default StoryContestWorks
